import type { MiceEventPremises } from '@voll-intelligence/domain';
import { t } from '@web/i18n';
import { StackedBar } from '@web/ui/core';
import { arrivalSegments, destinationPhrase } from './premises_summary';

const HOURS = ['00', '06', '12', '18'] as const;

/** Janela de chegada de cada aeroporto no dia (madrugada, ideal, tolerada), num eixo de 0 a 24 h. */
export function PremisesTimeline({ premises }: Readonly<{ premises: MiceEventPremises }>) {
  return (
    <section className="flex flex-col gap-2">
      <span className="text-meta font-medium text-foreground">{t('mice.premises.timeline')}</span>
      <div className="grid grid-cols-[minmax(0,7rem)_minmax(0,1fr)] items-center gap-x-3 gap-y-2">
        <span />
        <div className="grid grid-cols-4 font-mono text-tiny text-faint-foreground" aria-hidden>
          {HOURS.map((h) => (
            <span key={h}>{t('mice.premises.hour', { h })}</span>
          ))}
        </div>
        {premises.destinations.map((d) => (
          <div key={d.iata} className="contents">
            <span className="truncate font-mono text-meta text-foreground">{d.iata}</span>
            <StackedBar
              size="md"
              label={destinationPhrase(d)}
              segments={arrivalSegments(d, premises.redEye)}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
